var exports = {
  "k": "x804f0401--b5cd50--container",
};

module.exports = exports;
